import { type FC } from 'react'

import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { ProductInsurancePrescriptionBonusDialog } from '../ProductInsurancePrescriptionBonusDialog'
import { useProductPageContext } from '../productPageContext'
import { ProductPrivatePrescriptionBonusDialog } from '../ProductPrivatePrescriptionBonusDialog'

export const ProductPrescriptionBonusDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  const { currentPrescriptionType } = useProductPageContext()

  const isInsuranceOrFreePrescription =
    currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.InsurancePrescription ||
    currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.FreePrescription

  return (
    <>
      {currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.PrivatePrescription ? (
        <ProductPrivatePrescriptionBonusDialog
          isOpen={isOpen}
          onClose={onClose}
        />
      ) : null}
      {isInsuranceOrFreePrescription ? (
        <ProductInsurancePrescriptionBonusDialog
          isOpen={isOpen}
          onClose={onClose}
        />
      ) : null}
    </>
  )
}
